/**
 * WHETHER THE MODES' MOTION PLAYS on this screen - the crossings, the
 * ground easing, the beam.
 *
 * The viewer's own setting decides: always, never, or "follow my system".
 * The system's `prefers-reduced-motion` is only the DEFAULT, never a switch
 * of its own: as a stylesheet rule it silenced everything for a viewer
 * whose browser reports it, with nothing on screen to say why (the map's
 * sweep in v7.98.0, and every mode animation in v9.0.0-v9.1.1).
 *
 * Pure. Whoever calls supplies what the system says.
 */
export const MOTION_CHOICES = [
  { key: 'system', label: 'Follow my system', hint: 'Plays unless your system or browser asks for reduced motion.' },
  { key: 'on', label: 'Always play' },
  { key: 'off', label: 'Never' },
] as const;

export type MotionChoice = (typeof MOTION_CHOICES)[number]['key'];

/** The stored choice, or "follow my system" for anything else. */
export function motionChoice(stored: unknown): MotionChoice {
  return MOTION_CHOICES.some((c) => c.key === stored) ? (stored as MotionChoice) : 'system';
}

/** Should this screen hold still? A stored choice always wins over the system. */
export function holdsStill(stored: unknown, systemAsksForLess: boolean): boolean {
  const choice = motionChoice(stored);
  return choice === 'off' || (choice === 'system' && systemAsksForLess);
}
